export default {
  setAuthToken: (state, token) => {
    state.token = token

    if (token) {
      window.localStorage.setItem('jwt', token)
    } else {
      window.localStorage.removeItem('jwt')
    }
  },

  setSidebar: (state, show) => {
    state.showSidebar = show
  },

  updateWorkspaces: (state, workspaces) => {
    state.workspaces = workspaces
  },

  updateActiveWorkspace: (state, workspace) => {
    state.activeWorkspace = workspace
  },

  updateContentplans: (state, contentplans) => {
    state.contentplans = contentplans?.items || contentplans
  },

  updateActiveContentplan: (state, contentplan) => {
    state.activeContentplan = contentplan
  },

  updateContentplanKeywords: (state, keywords) => {
    state.keywords = keywords
  },

  updatePageKeywords: (state, keywords) => {
    state.pageKeywords = keywords
  },

  updateRelatedKeywords: (state, keywords) => {
    state.keywords.related = keywords
  },

  updateArticleKeywords: (state, keywords) => {
    state.keywords = keywords
  },

  updateArticleUrls: (state, urls) => {
    state.articleUrls = urls
  },

  addArticleUrlIfMissing: (state, urlEntry) => {
    if (!state.articleUrls) state.articleUrls = []
    if (!state.articleUrls.some(u => u.url === urlEntry.url)) {
      state.articleUrls.push(urlEntry)
    }
  },

  updateExternalUrls: (state, urls) => {
    state.articleExternalUrls = urls
  },

  updateScore: (state, score) => {
    state.score = score
  },

  loadTopics: (state, topics) => {
    state.topics = topics?.items || topics
  },

  setArticles: (state, articles) => {
    state.articles = articles
  },

  setTranslatedArticles: (state, response) => {
    state.translatedArticles = response.articles
    state.availableLanguages = response.availableLanguages
  },

  loadContentplanInternalURLs: (state, urls) => {
    state.internalUrls = urls
  },

  loadArticle: (state, article) => {
    state.article = article
  },

  loadTopicArticles: (state, response) => {
    state.topic.articles = response.articles
    state.topic.articlesRemaining = response.articlesRemaining
  },

  loadMoreTopicArticles: (state, response) => {
    state.topic.articles.push(...response.articles)
    state.topic.articlesRemaining = response.articlesRemaining
  },

  updateGSCDataByDate: (state, gscData) => {
    state.gsc.byDate = gscData
  },

  updateGSCDataByQuery: (state, gscData) => {
    state.gsc.byQuery = gscData
  },

  updateGSCDataByPage: (state, gscData) => {
    state.gsc.byPage = gscData
  },

  updateGSCDataByPageTypeDate: (state, gscData) => {
    state.gsc.byPageTypeDate = gscData
  },

  updateGSCDataByPageTypeSummary: (state, gscData) => {
    state.gsc.byPageTypeSummary = gscData
  },

  updateGSCPagination: (state, pagination = {}) => {
    state.gsc.pagination = {
      ...state.gsc.pagination,
      ...pagination
    }
  },

  updateGSCMeta: (state, meta = {}) => {
    state.gsc.meta = {
      ...state.gsc.meta,
      ...meta
    }
  },

  updatePages: (state, pages) => {
    state.pages = pages
  },

  // INTERNAL LINKS
  updateInternalLinks: (state, links) => {
    state.internalLinks = links
  },

  // CONTENTPLAN
  renameContentplan: (state, { contentplanId, name }) => {
    state.contentplans = state.contentplans.map(c => {
      if (c.id === contentplanId) {
        c.name = name
      }
      return c
    })
  },

  // TOPIC
  topicNew: (state, { topicId, name, contentplanId }) => {
    state.topics.push({
      id: topicId,
      name,
      contentplan_id: contentplanId
    })
  },

  topicRename: (state, { topicId, name }) => {
    state.topics = state.topics.map(t => {
      if (t.id === topicId) {
        t.name = name
      }
      return t
    })
  },

  topicExclude: (state, { topicIds }) => {
    state.topics = state.topics.filter(t => !topicIds.includes(t.id))
  },

  // PAGES
  pageExclude: (state, { pageIds }) => {
    state.pages = state.pages.filter(p => !pageIds.includes(p.page_id))
  },

  pageMatchLock: (state, { pageIds }) => {
    state.pages = state.pages.map(p => {
      if (pageIds.includes(p.page_id)) {
        p.article_id_locked = !p.article_id_locked
      }
      return p
    })
  },

  pageMatchUpdate: (state, { pageId, articleId }) => {
    state.pages = state.pages.map(p => {
      if (p.page_id === pageId) {
        p.article_id = articleId
        p.article_id_locked = true
      }
      return p
    })
  },

  // ARTICLES
  loadArticlesAdvanced: (state, articles) => {
    state.articles = articles.items
    state.keywords = articles.keywords
    state.articlesTotalCount = articles.meta?.totalCount || 0
  },

  removeArticle: (state, articleId) => {
    const index = state.articles.findIndex(a => a.article_id === articleId)
    if (index > -1) {
      state.articles.splice(index, 1)
    }
  },

  addArticle: (state, article) => {
    if (!state.articles.some(a => a.article_id === article.article_id)) {
      state.articles.push(article)
    }
  },

  articleRename: (state, { articleId, title }) => {
    state.articles = state.articles.map(a => {
      if (a.id === articleId) {
        a.title = title
      }
      return a
    })
  },

  articleMove: (state, { articleIds, topicId }) => {
    state.articles = state.articles.map(a => {
      if (articleIds.includes(a.id)) {
        a.topic_id = topicId
      }
      return a
    })
  },

  articleChangeTag: (state, { articleIds, tag, newValue }) => {
    state.articles = state.articles.map(a => {
      if (articleIds.includes(a.id)) {
        a[tag] = newValue
      }
      return a
    })
  },

  articleUpdateMainKeyword: (state, { articleId, keywordId, keyword }) => {
    // console.log('articleUpdateMainKeyword', articleId, keywordId)
    state.articles = state.articles.map(a => {
      if (a.id === articleId) {
        a.main_keyword_id = keywordId
        a.title = keyword
      }
      return a
    })
  },

  // KEYWORDS
  keywordExclude: (state, { keywordIds }) => {
    state.keywords = state.keywords.map(k => {
      if (keywordIds.includes(k.id)) {
        k.excluded = true
        k.article_id = null
      }
      return k
    })
  },

  keywordMoveCluster: (state, { keywordIds, articleId }) => {
    state.keywords = state.keywords.map(k => {
      if (keywordIds.includes(k.id)) {
        k.article_id = articleId
      }
      return k
    })
  },

  integrations: (state, data) => {
    state.integrations = Array.isArray(data) ? data : []
  },

  activeIntegration: (state, data) => {
    state.activeIntegration = data
  },

  setSnackbar: (state, data) => {
    state.snackbar = { ...data }
  },

  // Websocket mutations
  setWebsocket: (state, socket) => {
    state.websocket.instance = socket
  },

  setWebsocketConnected: (state, connected) => {
    state.websocket.connected = connected
  },

  setWebsocketInitializing: (state, initializing) => {
    state.websocket.initializing = initializing
  },

  incrementReconnectAttempts: (state) => {
    state.websocket.reconnectAttempts++
  },

  resetReconnectAttempts: (state) => {
    state.websocket.reconnectAttempts = 0
  },

  addWebsocketMessage: (state, message) => {
    state.websocket.messages.push(message)
    // Keep only the last 100 messages to prevent unbounded growth
    if (state.websocket.messages.length > 100) {
      state.websocket.messages = state.websocket.messages.slice(-100)
    }
  },

  clearWebsocketMessages: (state) => {
    state.websocket.messages = []
  },

  // PROGRESS TRACKERS
  addProgressTracker: (state, tracker) => {
    console.log('addProgressTracker', tracker)
    state.progressTrackers.push(tracker)
    // Automatically cleanup old trackers when adding new ones
    if (state.progressTrackers.length > 10) {
      state.progressTrackers = state.progressTrackers.slice(-10)
    }
  },

  updateProgressTracker: (state, { contentplanId, clusterId, stepName, status }) => {
    const trackerIndex = state.progressTrackers.findIndex(tracker => {
      const idMatch = clusterId ? tracker.clusterId === clusterId : tracker.contentplanId === contentplanId && !tracker.clusterId
      const stepExists = tracker.stepsObject && Object.prototype.hasOwnProperty.call(tracker.stepsObject, stepName)
      const canUpdate = stepExists && tracker.stepsObject[stepName] !== 'done' && tracker.stepsObject[stepName] !== 'error'
      return idMatch && canUpdate
    })

    if (trackerIndex !== -1) {
      // Vue Reactivity Caveat: Directly updating nested properties might not trigger reactivity.
      // Create a new stepsObject to ensure reactivity.
      const updatedSteps = { ...state.progressTrackers[trackerIndex].stepsObject, [stepName]: status }
      // Create a new tracker object to ensure reactivity
      const updatedTracker = { ...state.progressTrackers[trackerIndex], stepsObject: updatedSteps }
      // Replace the old tracker with the updated one using splice
      state.progressTrackers.splice(trackerIndex, 1, updatedTracker)
    } else {
      console.warn('Progress tracker not found for update or step already completed/errored:', { contentplanId, clusterId, stepName })
    }
  },

  removeProgressTracker: (state, { contentplanId, clusterId }) => {
    if (clusterId) state.progressTrackers = state.progressTrackers.filter(tracker => tracker.clusterId !== clusterId)
    else state.progressTrackers = state.progressTrackers.filter(tracker => tracker.contentplanId !== contentplanId)
  },

  clearProgressTrackers: (state) => {
    state.progressTrackers = []
  },

  // Automatic cleanup for completed progress trackers (keep only last 10)
  cleanupProgressTrackers: (state) => {
    if (state.progressTrackers.length > 10) {
      // Keep only the 10 most recent trackers
      state.progressTrackers = state.progressTrackers.slice(-10)
    }
  },

  // Memory optimization mutations
  clearLargeStateObjects: (state) => {
    // Clear large data objects that can accumulate
    state.articles = null
    state.pages = null
    state.keywords = null
    state.gsc.byDate = null
    state.gsc.byQuery = null
    state.gsc.byPage = null
    state.gsc.byPageTypeDate = null
    state.gsc.byPageTypeSummary = null
    state.gsc.pagination = {
      queryNextCursor: null,
      pageNextCursor: null
    }
    state.gsc.meta = {
      elapsedMs: 0,
      scRequestCount: 0,
      resultSizes: {
        DATE: 0,
        QUERY: 0,
        PAGE: 0,
        PAGE_TYPE: 0
      },
      paginationHops: {
        DATE: 0,
        QUERY: 0,
        PAGE: 0,
        PAGE_TYPE: 0
      },
      truncated: {
        byQuery: false,
        byPage: false,
        byPageType: false
      },
      partial: false,
      pageType: {
        language: null,
        filters: []
      }
    }
    state.pageKeywords = null
    state.benchmarks = null
    state.internalLinks = null
  },

  updateWorkspaceUsers: (state, users) => {
    state.workspaceUsers = users
  },

  // AUTOBLOG
  setAutoblogSettings: (state, settings) => {
    state.autoblogSettings = settings
  }
}
